import React, { useContext, useState, useEffect, useRef } from 'react';
import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MuiDrawer from '@mui/material/Drawer';
import { Outlet } from "react-router-dom";
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import CssBaseline from '@mui/material/CssBaseline';
import Typography from '@mui/material/Typography';
import { Tooltip, Snackbar, Alert } from "@mui/material";
import Divider from '@mui/material/Divider';
import DataMenu from './Menu';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import Slide from '@mui/material/Slide';
import LogoutIcon from '@mui/icons-material/Logout';
import CloseIcon from '@mui/icons-material/Close';
import Grid from '@mui/material/Grid';
import classes from './NavigationModulos.module.css';
import MenuIcon from '@mui/icons-material/Menu';
import logo_injupemp_white from './logo_injupemp_white.png'
import logo360Notificacion from '../img/Captura.PNG'
import { useMediaQuery } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { useLocation, useNavigate } from 'react-router-dom';
import { createContext } from "react";
import { ContextSession } from '../services/ContextSession';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import MailIcon from '@mui/icons-material/Mail';
import AppsIcon from '@mui/icons-material/Apps';
import Logo360 from '../Modules/Login/assets/INJUPEMP360.png'
import animation360 from './logo.json'
import Lottie from 'react-lottie-player';
import nuevaSolicitud from '../Modules/Portal del Participante/Call Center/nueva solicitud.mp3';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import ChatLottie from '../../src/img/ChatBotLottie.json';
import Joyride, { STATUS } from "react-joyride";
import { appColors } from "../services/theme.service";

const drawerWidth = 300;

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(11)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(12)} + 1px)`,
  },
});

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    ...(open && {
      ...openedMixin(theme),
      '& .MuiDrawer-paper': openedMixin(theme),
    }),
    ...(!open && {
      ...closedMixin(theme),
      '& .MuiDrawer-paper': closedMixin(theme),
    }),
  }),
);

const AppbarStyles = {
  appBar: {
    backgroundColor: 'black',
  },
  iconButton: {
    color: 'white',
  },
};

export default function MiniDrawer() {
  let [currentUrl, setCurrentUrl] = useState(window.location.pathname);
  const theme = useTheme();
  const [open, setOpen] = React.useState(true);
  let navigate = useNavigate();
  const location = useLocation();
  let sessi = useContext(ContextSession);
  const { sessionData } = useContext(ContextSession);
  const { nombre, apellido } = sessionData;
  const [token, setToken] = useState("0");
  let data = sessi.getMenu();
  const [unreadMessages, setUnreadMessages] = useState(0);
  const unreadMessagesRef = useRef(0);
  const audioRef = useRef(new Audio(nuevaSolicitud));
  const [openDialog2, setOpenDialog2] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [notificationPermission, setNotificationPermission] = useState('default');
  const [activeModule, setActiveModule] = useState(() => localStorage.getItem('activeModule') || "");
  const [allMenu, setAllMenu] = useState([]);
  const [tourRun, setTourRun] = useState(false);

  const getModuleName = (item) => {
    if (!item) return "";
    if (item.modulo) return item.modulo;
    if (Array.isArray(item) && item[0] && Array.isArray(item[0])) {
      return item[0][3] || "";
    }
    return "";
  };

  const filterMenuByModule = (menuData, moduleName) => {
    if (!moduleName) return menuData;
    const filtered = menuData.filter((item) => getModuleName(item) === moduleName);
    return filtered.length ? filtered : menuData;
  };

  // Verificar y solicitar permisos para notificaciones
  const requestNotificationPermission = () => {
    if (Notification.permission === 'granted') {
      setNotificationPermission('granted');
    } else if (Notification.permission !== 'denied') {
      Notification.requestPermission().then((permission) => {
        setNotificationPermission(permission);
      });
    }
  };

  // Redimensionar la imagen para la notificación del sistema
  const resizeImage = (imageSrc, width, height, callback) => {
    const img = new Image();
    img.src = imageSrc;
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, width, height);
      callback(canvas.toDataURL()); // Convertimos la imagen en base64
    };
  };

  useEffect(() => {
    // Solicitar permisos de notificación automáticamente al cargar la app
    if (Notification.permission !== 'granted' && Notification.permission !== 'denied') {
      Notification.requestPermission().then((permission) => {
        setNotificationPermission(permission);
      });
    } else {
      setNotificationPermission(Notification.permission);
    }
  }, []);


  // Mostrar la notificación del sistema
  const showSystemNotification = (title, options) => {
    if (notificationPermission === 'granted') {
      resizeImage(logo360Notificacion, 64, 64, (resizedImage) => {
        new Notification(title, { ...options, icon: resizedImage });
      });
    }
  };

  // Mostrar Snackbar y notificación del sistema
  const handleShowNotification = () => {
    setSnackbarOpen(true);
    showSystemNotification('Nueva notificación i360', {
      body: `Hola ${sessi.sessionData.nombre.split(' ')[0]} ${sessi.sessionData.apellido.split(' ')[0]}. Se ha recibido una nueva solicitud en ChatBot INJUPEMP Virtual.`,
      icon: logo360Notificacion, // Opcional: ícono de la notificación
      requireInteraction: true, // La notificación no se cerrará sola
    });
  };

  // Cerrar el Snackbar
  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  //console.log(data, "menu!!");
  const [openDialog, setOpenDialog] = useState(false);

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleCloseDialog2 = () => {
    setOpenDialog2(false);
  };

  const navegarConsultas = () => {
    setOpenDialog2(false);
    navigate("/PortalDelParticipante/ConsultasChatBot")
  };

  useEffect(() => {
    const container = document.getElementById('my-container');
    container.style.zoom = "80%";

    const handleBeforeUnload = (event) => {


      let token = sessi.getToken();

      //console.log("APP MAIN VAMOS A SALIR",token,token.length,"data clase",JSON.stringify(sessi.sessionData));
      if ((token != "" || token != 0 || token != "NA")) sessi.storeAuthData();

      //event.preventDefault();
    };
    window.addEventListener('beforeunload', handleBeforeUnload);

    let tok = sessi.getToken();
    let localpath = sessi.sessionData.path;
    //console.log("VAMOS A CHEKEAR TOKEN!!",tok.length);
    setToken(sessi.getToken());
    if (tok == "NA" || tok.length === 0) {
      navigate('/');
    } else {
      //console.log("CURRENT PATH STORAGE",sessi.sessionData.path);

      navigate(localpath == undefined || localpath == "" ? '/Inicio' : localpath);

      const nextMenu = sessi.getMenu();
      setAllMenu(nextMenu);
    }
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [token]);

  useEffect(() => {
    const hasTour = localStorage.getItem("i360_tour_done") === "1";
    if (!hasTour && location.pathname === "/Inicio") {
      setTourRun(true);
    }
  }, [location.pathname]);

  useEffect(() => {
    if (!allMenu.length) {
      setMenu([]);
      return;
    }
    const storedModule = localStorage.getItem('activeModule');
    if (!storedModule) {
      const fallback = getModuleName(allMenu[0]);
      if (fallback) {
        localStorage.setItem('activeModule', fallback);
        setActiveModule(fallback);
      }
    } else if (storedModule !== activeModule) {
      setActiveModule(storedModule);
    }
    setMenu(filterMenuByModule(allMenu, storedModule || activeModule));
  }, [allMenu, activeModule]);

  useEffect(() => {
    const storedModule = localStorage.getItem('activeModule') || "";
    if (storedModule && storedModule !== activeModule) {
      setActiveModule(storedModule);
    }
  }, [location.pathname]);

  useEffect(() => {
    const handleModuleChange = () => {
      const storedModule = localStorage.getItem('activeModule') || "";
      if (storedModule && storedModule !== activeModule) {
        setActiveModule(storedModule);
      }
    };
    window.addEventListener('active-module-changed', handleModuleChange);
    return () => window.removeEventListener('active-module-changed', handleModuleChange);
  }, [activeModule]);

  useEffect(() => {
    const fetchUnreadMessages = async () => {
      try {
        const response = await fetch(
          `https://chatbot.injupemp.gob.hn/contar_mensajes_no_leidos/${sessi.sessionData.id}/`
        );
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();

        const newCount = data.tickets_no_leidos;
        const previousCount = unreadMessagesRef.current;

        if (newCount > previousCount) {
          audioRef.current.play();
          setOpenDialog2(true);
          handleShowNotification(); // Mostrar la notificación cuando se detecta una nueva solicitud
        }

        unreadMessagesRef.current = newCount;
        setUnreadMessages(newCount);  // 🔹 Aquí aseguramos que `unreadMessages` se actualiza
      } catch (error) {
        console.error("Error fetching unread messages:", error);
      }
    };

    fetchUnreadMessages();
    const intervalId = setInterval(fetchUnreadMessages, 8000); // Cada 8 segundos
    //console.log("Unread Messages en Nav:", unreadMessages);

    return () => clearInterval(intervalId);
  }, [sessi.sessionData.id]);

  const [menu, setMenu] = React.useState(data);
  const [mostar, setMostar] = React.useState(false);
  const [mobileOpen, setMobileOpen] = React.useState(false); // Estado para el menú hamburguesa en dispositivos móviles
  const isMobile = useMediaQuery('(max-width:600px)'); // Detectar si es una pantalla móvil

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  function handleMenu(x, y) {
    if (y == -1)
      setMenu((men) => {
        men[x].mostrar = !men[x].mostrar;
        return men;
      });
    if (y > -1)
      setMenu((men) => {
        men[x].permisos[y].mostrar = !men[x].permisos[y].mostrar;
        return men;
      })
    setMostar((mos) => !mos);
    //console.log(menu);
  }

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
    // Si el drawer se cierra en la versión móvil, cambiar el estado de los submenús a cerrados
    if (isMobile && !mobileOpen) {
      setMenu(prevMenu => prevMenu.map(submenu => {
        if (submenu && submenu[0] && typeof submenu[0][6] !== 'undefined') {
          submenu[0][6] = false;
        }
        return submenu;
      }));
    }

  };

  const HandleLogout = () => {

    sessi.clearSession();
    navigate('/');
  };
  return (
    <div id="my-container">
        <Joyride
          run={tourRun}
          continuous
          showSkipButton
          scrollToFirstStep
          disableOverlayClose
          steps={[
            {
              target: '[data-tour="user-name"]',
              content: "Aqui puedes ver tu usuario y acceder al menu principal.",
              placement: "left",
            },
            {
              target: '[data-tour="module-cards"]',
              content: "Selecciona un modulo para comenzar.",
              placement: "top",
            },
            {
              target: '[data-tour="module-switch"]',
              content: "Cambia de modulo aqui para ver solo sus opciones.",
              placement: "right",
            },
            {
              target: '[data-tour="menu-list"]',
              content: "Este es el menu del modulo seleccionado.",
              placement: "right",
            },
            {
              target: '[data-tour="main-content"]',
              content: "Aqui se muestra el contenido de cada opcion.",
              placement: "top",
            },
          ]}
          styles={{
            options: {
              zIndex: 2000,
              primaryColor: "#22c55e",
            },
            beaconInner: {
              backgroundColor: "#22c55e",
            },
            beaconOuter: {
              borderColor: "#22c55e",
            },
          }}
          callback={(data) => {
            if ([STATUS.FINISHED, STATUS.SKIPPED].includes(data.status)) {
              localStorage.setItem("i360_tour_done", "1");
              setTourRun(false);
            }
          }}
        />
        <Box sx={{ display: 'flex' }}>
          <CssBaseline />
          {isMobile && !open && ( // Renderizar AppBar solo en pantallas móviles
            <AppBar position="fixed" data-tour="appbar">
              <Toolbar>
                <IconButton
                  color="default"
                  aria-label="open drawer"
                  edge="start"
                  onClick={handleDrawerOpen}
                  sx={{ mr: 2, display: { sm: 'none' }, ...AppbarStyles.iconButton }}
                >
                  {mobileOpen ? <MenuIcon /> : <MenuIcon />}
                </IconButton>
                <Grid item md={2.2} >
                  {/* Lottie Animation */}
                  <div style={{ display: 'flex', alignItems: 'center', marginRight: 10 }}>
                    <Lottie loop animationData={animation360} play style={{ width: '10%', height: 'auto' }} />

                    {/* Logo */}
                    <img src={Logo360} alt="INJUPEMP 360°" style={{ height: 30, marginLeft: 2 }} />
                  </div>
                </Grid>
              </Toolbar>
            </AppBar>
          )}
          {!isMobile && (<AppBar position="fixed" open={open} data-tour="appbar">
            <Toolbar sx={{
              display: 'flex',
              justifyContent: 'space-between',
              height: open ? 90 : 'auto' // si open es true, altura es 90, sino es auto
            }}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Tooltip title="Abrir Menú">
                  <IconButton
                    color="inherit"
                    aria-label="open drawer"
                    onClick={handleDrawerOpen}
                    edge="start"
                    sx={{
                      marginRight: 1, // Ajustar el margen según sea necesario
                      ...(open && { display: 'none' }),
                      color: 'white'
                    }}
                  >
                    <MenuIcon />
                  </IconButton>
                </Tooltip>

                {/* Lottie Animation */}
                <div style={{ display: 'flex', alignItems: 'center', marginRight: 10 }}>
                  <Lottie loop animationData={animation360} play style={{ width: '5%', height: 'auto' }} />

                  {/* Logo */}
                  <img src={Logo360} alt="INJUPEMP 360°" style={{ height: 30, marginLeft: 2 }} />
                </div>
              </div>

              <a title='Cerrar Sesión'>
                <Button
                  data-tour="user-name"
                  onClick={handleOpenDialog}
                  sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                >
                  <AccountCircleIcon sx={{ fontSize: 'small', marginLeft: '30px', color: 'white' }} />
                  <Typography variant="h6" component="span" sx={{ fontSize: 'small', color: 'white' }}>
                    {nombre} {apellido}
                  </Typography>
                </Button>
              </a>
            </Toolbar>
          </AppBar>)}
          <Drawer variant="permanent" open={open}>
            <DrawerHeader style={{ backgroundColor: appColors.brand.primary }}>
              {open && ( // Verifica si open es true para mostrar la imagen
                <Grid container item justifyContent="center">
                  <img style={{ width: 200, margin: 10 }} src={logo_injupemp_white} />
                </Grid>
              )}
              <Tooltip title="Cerrar Menú" >
                <IconButton onClick={handleDrawerClose}>
                  {theme.direction === 'rtl' ? <ChevronRightIcon style={{ color: 'white' }} /> : <ChevronLeftIcon style={{ color: 'white' }} />}
                </IconButton>
              </Tooltip>
            </DrawerHeader>
            <Divider />
            {open ? (
              <Box sx={{ overflow: 'auto', flexGrow: 1 }}>
                <Divider />
                <List className={classes.menuItem} data-tour="menu-list">
                  <ListItem disablePadding sx={{ display: 'block' }} data-tour="module-switch">
                    <ListItemButton
                      onClick={() => navigate('/Inicio')}
                      sx={{ minHeight: 44, px: 2.5, alignItems: 'flex-start' }}
                    >
                      <ListItemIcon sx={{ minWidth: 0, mr: 2, justifyContent: 'center' }}>
                        <AppsIcon style={{ color: appColors.neutral.gray700 }} />
                      </ListItemIcon>
                      <ListItemText
                        primary={activeModule ? `Modulo: ${activeModule}` : 'Elegir modulo'}
                        primaryTypographyProps={{
                          sx: {
                            whiteSpace: 'normal',
                            wordBreak: 'break-word',
                            overflowWrap: 'anywhere',
                            lineHeight: 1.2,
                          },
                        }}
                        sx={{ opacity: 1, m: 0 }}
                      />
                    </ListItemButton>
                    <Divider color='white' />
                  </ListItem>
                  {menu.length >= 1 &&
                    menu.map((submenu, index) => (
                      <DataMenu
                        HandleLogout={HandleLogout}
                        key={index}
                        x={index}
                        moss={mostar}
                        texto={submenu}
                        handlMenu={handleMenu}
                        cerrar={handleDrawerToggle}
                        abierto={open}
                        unreadMessages={unreadMessages} // Pasar el conteo de mensajes no leídos
                      />
                    ))}
                </List>
              </Box>
            ) : (
              <Box sx={{ overflow: 'inherit', flexGrow: 0 }}>
                <Divider />
                <List className={classes.menuItem} data-tour="menu-list">
                  <Tooltip title="Cambiar modulo" placement="right">
                    <ListItem disablePadding sx={{ display: 'block' }} data-tour="module-switch">
                      <ListItemButton
                        onClick={() => navigate('/Inicio')}
                        sx={{ minHeight: 44, px: 2.5 }}
                      >
                        <ListItemIcon sx={{ minWidth: 0, mr: 2, justifyContent: 'center' }}>
                          <AppsIcon style={{ color: appColors.neutral.gray700 }} />
                        </ListItemIcon>
                      </ListItemButton>
                    </ListItem>
                  </Tooltip>
                  {menu.length >= 1 &&
                    menu.map((submenu, index) => (
                      <DataMenu
                        HandleLogout={HandleLogout}
                        key={index}
                        x={index}
                        moss={mostar}
                        texto={submenu}
                        handlMenu={handleMenu}
                        cerrar={handleDrawerToggle}
                        abierto={open}
                        unreadMessages={unreadMessages} // Pasar el conteo de mensajes no leídos
                      />
                    ))}
                </List>
              </Box>
            )}

            <Box sx={{ alignSelf: 'flex-end', marginRight: '60px' }}>
              {open && ( // Condición para mostrar el botón solo cuando el drawer está abierto
                <Button
                  onClick={handleOpenDialog}
                  fullWidth
                  endIcon={<LogoutIcon />}
                  sx={{ transform: 'translateX(-20%)', color: 'grey' }}
                >
                  Cerrar Sesión
                </Button>
              )}
            </Box>

          </Drawer>
          <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
            <DrawerHeader />
            <main className={classes.main} data-tour="main-content">
              <Outlet />
            </main>
          </Box>
        </Box>
        <Dialog
          open={openDialog}
          onClose={handleCloseDialog}
          TransitionComponent={Transition}
          PaperProps={{
            sx: {
              borderRadius: 3,
              width: 400,
              overflow: 'hidden',
              boxShadow: '0 24px 60px rgba(15, 23, 42, 0.25)',
            },
          }}
        >
          <DialogTitle sx={{ pb: 0, placeItems:'Center'}}>
            <Box sx={{ display: 'flex', alignItems: 'center', placeItems:'Center', gap: 1.5 }}>
              <Box
                sx={{
                  width: 36,
                  height: 36,
                  borderRadius: '50%',
                  display: 'grid',
                  placeItems: 'center',
                  justifyContent: 'center',
                  bgcolor: 'rgba(68, 71, 239, 0.12)',
                }}
              >
                <LogoutIcon sx={{ color: '#19438C', fontSize: 30 }} />
              </Box>
              
            </Box>
          </DialogTitle>
          <DialogContent sx={{ pt: 1, marginTop: 3, placeItems:'Center' }}>
            <DialogContentText sx={{ color: 'text.secondary' }}>
              ¿Quieres salir ahora?
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ px: 3, pb: 3, pt: 1, gap: 1.5,   justifyContent: 'center' }}>
            <Button
              onClick={handleCloseDialog}
              variant="outlined"
              startIcon={<CloseIcon />}
              sx={{
                borderColor: 'rgba(15, 23, 42, 0.12)',
                color: '#AD8401',
              }}
            >
              Cancelar
            </Button>
            <Button
              onClick={HandleLogout}
              variant="contained"
              color="info"
              endIcon={<LogoutIcon />}
              disableElevation
              sx={{ fontWeight: 600, backgroundColor:'#19438C' }}
            >
              Salir
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog open={openDialog2} onClose={handleCloseDialog2} TransitionComponent={Transition}>
          <DialogTitle>{"Nueva Solicitud Recibida en ChatBot INJUPEMP Virtual"}</DialogTitle>
          <Box display="flex" justifyContent="center" alignItems="center">
            <Lottie loop animationData={ChatLottie} play style={{ width: '15%', height: 'auto' }} />
          </Box>
          <DialogActions sx={{ display: "flex", justifyContent: "center", gap: 2 }}>
            <Button
              onClick={handleCloseDialog2}
              variant="contained"
              color="error"
              startIcon={<CloseIcon />}
            >
              Cerrar
            </Button>
            <Button
              onClick={navegarConsultas}
              variant="contained"
            >
              Ir a Consultas
            </Button>
          </DialogActions>

        </Dialog>
        <Snackbar
          open={snackbarOpen}
          autoHideDuration={6000}
          onClose={handleCloseSnackbar}
        >
          <Alert onClose={handleCloseSnackbar} severity="info">
            Tienes una nueva solicitud en el ChatBot INJUPEMP Virtual
          </Alert>
        </Snackbar>

    </div>
  );
}

